import { useCategoryNodeQuery } from 'lib-knowledge-management-common/graphql';

type UseCategoryFetchReturnValue = ReturnType<typeof useCategoryNodeQuery>;

function useCategoryFetch({
  categoryId,
}: {
  categoryId: string;
  skip?: boolean;
}): UseCategoryFetchReturnValue {
  return useCategoryNodeQuery({
    variables: {
      id: categoryId,
    },
  });
}

export default useCategoryFetch;
